'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _auditsbymonth = require('./auditsbymonth.html');

var _auditsbymonth2 = _interopRequireDefault(_auditsbymonth);

var _auditsbymonth3 = require('./auditsbymonth.controller');

var _auditsbymonth4 = _interopRequireDefault(_auditsbymonth3);

require('./auditsbymonth.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var auditsbymonthComponent = {
  restrict: 'E',
  bindings: {},
  template: _auditsbymonth2.default,
  controller: _auditsbymonth4.default,
  controllerAs: 'vm'
};

exports.default = auditsbymonthComponent;


// WEBPACK FOOTER //
// ./client/app/common/reports/auditsbymonth/auditsbymonth.component.js